import { render } from "./practice-bank.html?vue&type=template&id=356d1d04&scoped=true&ts=true&external"
import script from "./practice-bank.ts?vue&type=script&lang=ts&external"
export * from "./practice-bank.ts?vue&type=script&lang=ts&external"

import "./practice-bank.scss?vue&type=style&index=0&id=356d1d04&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356d1d04"]])

export default __exports__